import React from 'react'

import shape from "../../../src/images/faxian-it-images/shape.png"
import work1 from "../../../src/images/faxian-it-images/work-1.jpg"
import consultation from "../../../src/images/faxian-it-images/consultation.png"

function WhytoChoose() {
  return (
    <div>
      
      

  {/* Start Work Area  */}
            <div className="work-area work-style-one tmp-section-gap">
                <div className="container">
                <div className="row">
                    <div className="work-top-inner">
                    <div className="section-head pb-0 section-head-one-side text-align-left">
                        <div className="section-sub-title color-white ">
                        <span className="subtitle">WHY CHOOSE US</span>
                        </div>
                        <h2 className="title color-white split-collab">
                       Technology with empathy, <br /> solutions with impact.
                        </h2>
                    </div>
                    <div
                        className="single-work-top"
                        data-sal-delay={250}
                        data-sal="slide-up"
                        data-sal-duration={800}
                    >
                        <h2 className="title">24 / 7</h2>
                        <div className="sub-title">Reliable Support</div>
                    </div>
                    <div className="scater-line">
                        <img src={shape} alt=""  loading="lazy" />
                    </div>
                    </div>
                </div>
                <div className="row g-5">
                    <div
                    className="col-lg-6 col-md-6"
                    data-sal-delay={150}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    <div className="inner">
                        <a href="#">
                        <div className="thumbnail">
                            <img
                            className="large"
                            src={work1}
                            alt="Business Consulting"  loading="lazy" 
                            />
                        </div>
                        </a>
                    </div>
                    </div>
                    <div
                    className="col-lg-3 col-md-6"
                    data-sal-delay={250}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    <div className="single-work style-one mt--35" style={{height:'85%'}}>
                        <a href="#">
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src={consultation}
                                alt="Business Consulting"  loading="lazy" 
                            />
                            </div>
                            <h3 className="title">Proven Expertise</h3>
                            <p className="description">
                          At FaxianIT, we don’t just deliver technology — we deliver transformation. Our focus on innovation, customer-centricity, and long-term value makes us the trusted partner for businesses worldwide.
                            </p>
                        </div>
                        </a>
                    </div>
                    </div>
                    <div
                    className="col-lg-3 col-md-12"
                    data-sal-delay={350}
                    data-sal="slide-up"
                    data-sal-duration={800}
                    >
                    <div className="single-work style-one">
                        <a href="#" className="cart-box cart-box-1">
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src={consultation}
                                alt="Business Consulting"  loading="lazy" 
                            />
                            </div>
                            <h3 className="title">Client-Centered Approach</h3>
                        </div>
                        </a>
                    </div>
                    <div className="single-work style-one mt--30">
                        <a href="#">
                        <div className="work-inner">
                            <div className="thumbnail">
                            <img
                                src={consultation}
                                alt="Business Consulting"  loading="lazy" 
                            /> 
                            </div>
                            <h3 className="title">Global Perspective</h3>
                        </div>
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            {/* End Work Area  */}

        



    </div>
  )
}

export default WhytoChoose
